if (!customElements.get('os-reading-progress')) {
  class OsReadingProgress extends HTMLElement {
    #frame = null;

    connectedCallback() {
      this.bar = this.querySelector('.os-rp__bar');
      this.header = document.querySelector('.section-header');
      this.onScroll = () => {
        if (this.#frame) return;
        this.#frame = requestAnimationFrame(() => {
          this.#frame = null;
          this.#update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.#update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.#frame) cancelAnimationFrame(this.#frame);
    }

    #update() {
      let offset = 0;
      if (this.dataset.position === 'header' && this.header) {
        offset = Math.max(0, this.header.getBoundingClientRect().bottom);
      }
      this.style.transform = `translateY(${offset}px)`;

      const target =
        document.querySelector('.article-template__content') ||
        document.querySelector('main');
      const rect = target.getBoundingClientRect();
      const start = window.scrollY + rect.top - offset;
      const end = window.scrollY + rect.bottom - window.innerHeight;
      let progress = 0;
      if (end > start) {
        progress = (window.scrollY - start) / (end - start);
      } else {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        progress = max > 0 ? window.scrollY / max : 1;
      }
      progress = Math.min(1, Math.max(0, progress));
      this.bar.style.transform = `scaleX(${progress})`;
    }
  }

  customElements.define('os-reading-progress', OsReadingProgress);
}
